import {
  getCapability,
  type AgentMessage,
  type AgentToolDefinition,
  type CapabilityEffect,
} from "@calcplan/ai-capabilities";

const ANSWER_ONLY_EXCLUDED_TOOLS = new Set([
  "skill.load",
  "ui.ask",
  "task.plan.propose",
  "task.plan.progress",
  "task.plan.amend",
  "task.plan.review",
  "scene.viewport.review",
]);

export function answerOnlyToolDefinitions(
  tools: readonly AgentToolDefinition[],
): AgentToolDefinition[] {
  return tools.filter((tool) => {
    const capability = getCapability(tool.name);
    return capability?.effect === "read" && !ANSWER_ONLY_EXCLUDED_TOOLS.has(tool.name);
  });
}

/** The effective capability is checked again after capability.invoke is parsed. */
export function answerOnlyCapabilityAllowed(name: string, effect: CapabilityEffect): boolean {
  return effect === "read" && !ANSWER_ONLY_EXCLUDED_TOOLS.has(name);
}

export function answerOnlySearchResult(result: unknown): unknown {
  if (!result || typeof result !== "object" || Array.isArray(result)) return result;
  const record = result as Record<string, unknown>;
  if (!Array.isArray(record.capabilities)) return result;
  return {
    ...record,
    capabilities: record.capabilities.filter((entry) => {
      if (!entry || typeof entry !== "object" || Array.isArray(entry)) return false;
      const capability = entry as Record<string, unknown>;
      return typeof capability.name === "string"
        && answerOnlyCapabilityAllowed(capability.name, capability.effect as CapabilityEffect);
    }),
  };
}

export function recentConversationForIntent(
  messages: readonly AgentMessage[],
): Array<{ role: "user" | "assistant"; text: string }> {
  return messages.flatMap((message) => {
    const text = message.content
      .filter((block) => block.type === "text" && !block.text.startsWith("[Controle interno do CalcPlan"))
      .map((block) => block.type === "text" ? block.text : "")
      .join("\n")
      .trim();
    return text ? [{ role: message.role, text: text.slice(0, 4_000) }] : [];
  }).slice(-16);
}
